import './index.less';
import React, { useState } from 'react';
import LayoutPlus from '@/componentsUI/LayoutPlus/Layout/LayoutPlus';
import TableHeaderOnly2Items from '@/components/tableHeaderOnly2Items/TableHeaderOnly2Items';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import { useGlobalCurrentWallet } from '@/store/commonStore';
import Crypto from './crypto/Crypto';
import { useWalletAll } from '@/store/walletStore';
import FlatWidthdraw from './flat/FlatWidthdraw';
const Withdraw = () => {
  const { t } = useTranslationPlus('Wallet');
  const { data } = useWalletAll();
  /**当前使用的钱包 */
  const [currentWalletGlobal] = useGlobalCurrentWallet();
  const { crypto: cryptoWallet, flat: flatWallet } = data || {};

  function initTabIndex() {
    if (currentWalletGlobal?.currencyCategory === 1) {
      if (cryptoWallet?.length) {
        //加密
        return '1'
      } else if (flatWallet?.length) {
        //法币
        return '2'
      }
    } else if (currentWalletGlobal?.currencyCategory === 2) {
      //法币
      if (flatWallet?.length) {
        return '2'
      } else if (cryptoWallet?.length) {
        return '1'
      }
    }
  }
  const [activeTab, setActiveTab] = useState<string>(initTabIndex());

  function isShow() {
    if (cryptoWallet?.length && flatWallet?.length) {
      return true;
    }
    return false;
  }

  const prefixCls = 'wallet-withdraw';

  return (
    <LayoutPlus
      className={`${prefixCls}`}
      header={
        <TableHeaderOnly2Items
          className={`${prefixCls}-header`}
          text1={isShow() ? t('CryptoCurrency') : undefined}
          text2={isShow() ? t('FlatCurrency') : undefined}
          value={activeTab}
          onChange={setActiveTab}
        />
      }
    >
      {activeTab === '1' && <div>
        <Crypto />
      </div>}

      {activeTab === '2' && <div>
        <FlatWidthdraw />
      </div>}
    </LayoutPlus>
  );
};

export default Withdraw;
